import NumberFormat from 'common/services/number_format';

export const formatCurrency = (value) =>
    NumberFormat.currency(Number(value.toString()));
